import { observer } from "mobx-react";
import { FC, useEffect } from "react";
import { ArticleSelectorQuestion, LocalizedMarkdownQuestion } from "@/dbot/common/commonComponents";
import { ChangeCompanyBoardInArticlesOfAssociationForm } from "./changeCompanyBoardInArticlesOfAssociationDomain";
import { VBox } from "@/components-v2/Box";

import { useTranslation } from "@/stores/RootStoreContext";

export const ChangeCompanyBoardInArticlesOfAssociationView: FC<{
  form: ChangeCompanyBoardInArticlesOfAssociationForm;
}> = observer(({ form }) => {
  const { t } = useTranslation();

  useEffect(() => form.init(), [form]);

  return (
    <VBox gap={"md"}>
      <ArticleSelectorQuestion
        question={t("decisions.companyBoard.change-paragraph.what-paragraph")}
        onChange={form.setParagraphValue}
        model={form.paragraph}
        isLocked={form.isProjectLocked}
      />
      <LocalizedMarkdownQuestion
        name={"article-texts"}
        question={t("decisions.companyBoard.change-paragraph.change-text-paragraph")}
        textModels={form.texts}
        isLocked={form.isProjectLocked}
      />
    </VBox>
  );
});
